module.exports = __webpack_public_path__ + "web/img/loader.e75660be.gif";